module.exports = __webpack_public_path__ + "48aca9afc3721a2bee353eeb8fb7088e.png";